function normalize(path: string): string {
  const withoutQuery = path.split(/[?#]/)[0]
  return withoutQuery.length > 1 ? withoutQuery.replace(/\/+$/, '') : withoutQuery
}

// `*` stands for any run of characters, like in Unpoly's up-alias patterns.
function patternToRegExp(pattern: string): RegExp {
  const source = pattern
    .split('*')
    .map((part) => part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('.*')
  return new RegExp(`^${source}$`)
}

export function isCurrentPath(href: string, currentPath: string): boolean {
  if (!href.startsWith('/')) return false

  return normalize(href) === normalize(currentPath)
}

// Pages below an entry have to be claimed explicitly: a path being a prefix of another says nothing
// about the two belonging together (`/lernen` is not the parent of a learn session).
export function matchesPathPattern(pattern: string, currentPath: string): boolean {
  if (!pattern.startsWith('/')) return false

  return patternToRegExp(normalize(pattern)).test(normalize(currentPath))
}

interface MenuEntry {
  href?: string
  currentPaths?: string[]
  target?: string
  method?: string
  children?: MenuEntry[]
}

export function isCurrentItem(item: MenuEntry, currentPath: string): boolean {
  if (item.target || item.method || !item.href) return false

  return (
    isCurrentPath(item.href, currentPath) ||
    (item.currentPaths ?? []).some((pattern) => matchesPathPattern(pattern, currentPath)) ||
    (item.children ?? []).some((child) => isCurrentItem(child, currentPath))
  )
}

export function menuHasCurrentPath(items: MenuEntry[], currentPath: string): boolean {
  return items.some((item) => isCurrentItem(item, currentPath))
}
